<template>
  <BaseAddMethodLayout v-bind="layoutProps">
    <template v-for="method in methods">
      <PaymentTypeButton
        v-if="method.enabled"
        :key="method.id"
        :title="$t('wallet.methods.' + method.title)"
        :icon="method.icon"
        :fee="getFee(method.fee)"
        :funds="$t('wallet.' + method.funds)"
        @click.native="withdrawMethods(method.type)"
        v-bind="method"
      />
    </template>
  </BaseAddMethodLayout>
</template>

<script>
import { BaseAddMethodLayout } from '@/modules/walletv2/WalletModals';
import { PaymentTypeButton } from '@/components/misc';
import CirclePaymentType from '@/enums/CirclePaymentType.js';
import { validateMethodOfPayment } from '../types';

export default {
  name: 'AddWithdrawMethods',
  components: {
    BaseAddMethodLayout,
    PaymentTypeButton,
  },
  props: {
    balance: {
      type: String,
      required: true,
    },
    kycComplete: {
      type: Boolean,
      required: true,
    },
    limit: {
      type: String,
      required: true,
    },
    methods: {
      type: Array,
      required: true,
      validator: validateMethodOfPayment,
    },
    openPlaidWidget: {
      type: Function,
      required: true,
    },
    type: {
      type: String,
      default: 'withdraw',
    },
  },
  computed: {
    layoutProps() {
      return {
        balance: this.balance,
        limit: this.limit,
        showIncreaseLimitButton: false,
        type: this.type,
      };
    },
  },
  methods: {
    getFee(fee) {
      if (fee <= 0) {
        return this.$t('wallet.methods.no_fee');
      } else {
        return `${this.numberFormat(fee, 2, false, true)} ${this.$t('wallet.methods.fee')}`;
      }
    },
    async withdrawMethods(type) {
      switch (type) {
        case CirclePaymentType.ACH:
          await this.$store.dispatch('events/track', {
            event: 'ADD_ACH_VIEWED',
            variables: {
              transfer_method: 'withdraw',
            },
          });
          return this.openPlaidWidget();
        case CirclePaymentType.CARD:
          await this.$store.dispatch('events/track', {
            event: 'ADD_CREDIT_CARD_VIEWED',
          });
          return this.showModal('AddCreditCardMethod');
        case CirclePaymentType.BLOCKCHAIN:
          await this.$store.dispatch('events/track', {
            event: 'ADD_USDC_VIEWED',
          });
          return this.showModal('PaymentInterface', {
            isDeposit: false,
            selectedMethodId: CirclePaymentType.BLOCKCHAIN,
          });
        case CirclePaymentType.WIRE:
          await this.$store.dispatch('events/track', {
            event: 'ADD_WIRE_VIEWED',
          });
          return this.showModal('WalletAddWireTransferDetails', { isDeposit: false });
        default:
          throw Error('This transfer method don\'t exist');
      }
    },
  },
};
</script>
